import { apiCall } from "@/common/api/ApiResult.model";
import axios from "axios";
import { MipLabel } from "../../data/model";

// https://app.clickup.com/3752527/v/dc/3jgjf-26305/3jgjf-13925
export const getMipLabelsTree = apiCall<
  void,
  { labels: MipLabel[]; missing: number; is_empty: boolean }
>("mip-get-labels-tree", async () => {
  const res = await axios.get(
    "/mip/labels/getLabels?cid=ca9befe5-f089-498a-8e8d-8f10f0bfd404"
  );
  return {
    success: true,
    value: {
      ...res.data,
      is_empty: res.status === 204,
    },
  };
});

export const apply_manual_label = apiCall<
  { file_url: string; label_id: string },
  boolean
>("mip-manual-label", async ({ label_id, file_url }) => {
  await axios.post("/mip/labels/manual/apply", {
    labelId: label_id,
    fileUrl: file_url,
  });
  return {
    success: true,
    value: true,
  };
});
